import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import UpdateListWidgets from '../../../widgets/updateListWidgets/UpdateListWidgets'
import '../styles.less'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import { getAdjust } from '../../../redux/actions/accountingAdjust'

//บันทึกปรับปรุงรายการ
export default function UpdateList() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')
  const { adjustId, editMode } = sessionGetItemObj('adjustData')
  const { periodNumber } = sessionGetItemObj('periodInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAdjust(projectCode, periodNumber, adjustId)

      // console.log('getLegalManagement ', _schema)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpense>
        <ContentHeader
          header={schema.header}
          subHeader={''}
          isNotCallApi
          isShowGoButton
          cleanSessions={['adjustData']}
        />

        <UpdateListWidgets schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
